"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION = exports.INITIAL_VALUES = exports.FIELDS = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var TRANSLATION = {
  pwdTitle: 'Enter your PWD ID (If applicable)',
  pwdSubTitle: 'Waive the wheelchair fee with your PWD ID',
  pwdTextLabel: 'Identification Number',
  pwdNote:
  // eslint-disable-next-line
  'PWD ID is Person with Disability Identification. You’ll need to present the ID during counter check-in to confirm its validity. Failure in doing so will lead to applicable fee charges at the airport.',
  pwdNoteTitle: 'What is PWD ID?',
  requiredError: 'This field is required.',
  maxLengthError: 'Max allowed charater is {max}.',
  alphanumericError: 'Please use English characters (A to Z) only. Special characters or symbols are not allowed.'
};
exports.TRANSLATION = TRANSLATION;
var FIELDS = {
  pwdId: {
    label: TRANSLATION.pwdTextLabel,
    name: 'pwdId'
  }
};
exports.FIELDS = FIELDS;
var INITIAL_VALUES = _objectSpread({}, Object.keys(FIELDS).reduce(function (acc, curr) {
  acc[curr] = '';
  return acc;
}, {}));
exports.INITIAL_VALUES = INITIAL_VALUES;